import styled from 'styled-components'

export const TimerPageContainer = styled.div`
  background: ${({ theme }) => theme?.themeC4};
  min-height: calc(100vh);
  gap: 10px;
  padding-top: 100px;
  padding: 100px 10px 20px;
  ${'' /* background: #20142d; */}
`
